import SearchFormSidebar from '@components/collection/Collection/SearchFormSidebar'
import CollectionSearchResultsView from '@components/collection/Collection/CollectionSearchResultsView'
import CollectionRunsheetsView from '@components/collection/Collection/CollectionRunsheetsView'
import { Mosaic } from 'react-mosaic-component'
import { useMemo } from 'react'

/**
 * 
 * @param {CollectionViewModel} vm
 * @returns {JSX.Element}
 * @constructor
 */
const CollectionDocumentSearchView = ({
    vm,
}) => {
    
    const sidebar = useMemo(() => (
        
        <form
            className="CollectionDocumentSearchView min-w-[200px] overflow-x-hidden pr-3"
            name="searchForm"
            onSubmit={vm.handleSubmit}>
            
            <div className="flex gap-2 mb-3 sticky top-0 bg-dark">
                <button
                    className="btn btn-primary flex-1"
                    type="submit">
                    Search
                </button>
                <button
                    className="btn btn-secondary"
                    type="button" onClick={e => vm.handleFormReset(e)}>
                    Clear
                </button>
            </div>
            
            <SearchFormSidebar
                activeTab={vm.activeTab}
                handleKeyUp={vm.handleKeyUp}
                handleChange={vm.handleChange} />
        
        </form>
        
    ), [vm])
    
    return (
        
        <Mosaic
            className="parse-mosaic mt-2"
            renderTile={id => ({
                sidebar,
                docs: <CollectionSearchResultsView vm={vm} />,
                runsheets: vm.selectedRunsheet && <CollectionRunsheetsView vm={vm} />,
            })[id]}
            resize={{ minimumPaneSizePercentage: 0 }}
            initialValue={{
                direction: 'row',
                
                // sets the starting split percentage according to window width
                splitPercentage: (260 / window.innerWidth) * 100,
                first: 'sidebar',
                second: !vm.selectedRunsheet ? 'docs' : {
                    direction: 'column',
                    first: 'docs',
                    second: 'runsheets',
                    splitPercentage: vm.selectedRunsheet ? 50 : 100,
                },
            }} />
        
    )
    
}

export default CollectionDocumentSearchView
